var t = {};
export {
  t as __exports
};
//# sourceMappingURL=contact-channels242.js.map
